export default "__VITE_ASSET__c949642a__"